import { config } from '@iheartjane/config';
import qs from 'qs';

/* eslint-disable-next-line no-restricted-imports */
import type {
  CrmIntegration,
  CrmProviderType,
  CrmRedemption,
} from '@jane/shared/models';
import type { Address } from '@jane/shared/types';

import { request } from '@jane/monolith/lib/request';

export interface CrmIntegrationResponse {
  crm_integration?: CrmIntegration;
  error?: string;
  integration_type: 'phone' | 'email' | null;
}

export const getCrmIntegration = (
  storeId: string | number,
  crmMemberId: string | null,
  email: string | null,
  authCode?: string
) => ({
  url: `${config.apiPath}/stores/${storeId}/crm_integration?${qs.stringify({
    crm_member_id: crmMemberId,
    auth_code: authCode,
    email,
  })}`,
});

export const applyCrmRedemption = (
  redemption: CrmRedemption,
  delivery_address?: Address | null
) =>
  request(`${config.apiPath}/carts/apply_crm_redemption`, {
    method: 'POST',
    body: JSON.stringify({ ...redemption, delivery_address }),
  });

export const removeCrmRedemption = (
  id: string | number,
  crmProvider: CrmProviderType
) =>
  request(`${config.apiPath}/carts/remove_crm_redemption`, {
    method: 'DELETE',
    body: JSON.stringify({ id, crm_provider: crmProvider }),
  });

export const initiateCrmAuth = (cartUuid: string) =>
  request(`${config.apiPath}/carts/initiate_crm_auth`, {
    method: 'POST',
    body: JSON.stringify({ cart_uuid: cartUuid }),
  });
